import React from "react";
import { useTranslation } from "react-i18next";
import { useColleagues } from "../hooks/useColleagues";

/** Sentinel filter value for members without an assigned instructor. */
export const UNASSIGNED_INSTRUCTOR = "unassigned";

interface InstructorFilterSelectProps {
  /** Selected instructor id, UNASSIGNED_INSTRUCTOR, or null = all instructors. */
  value: string | null;
  onChange: (value: string | null) => void;
  /** Adds an "Unassigned" option (members list). */
  includeUnassigned?: boolean;
}

/**
 * "All instructors / per-instructor" filter for the sessions and members
 * lists — the same select the calendar toolbar renders. Loads the roster
 * itself and renders nothing in a solo organization.
 */
const InstructorFilterSelect: React.FC<InstructorFilterSelectProps> = ({
  value,
  onChange,
  includeUnassigned = false,
}) => {
  const { t } = useTranslation();
  const { activeColleagues, isMultiInstructor } = useColleagues();

  if (!isMultiInstructor) {
    return null;
  }

  return (
    <select
      aria-label={t("instructors.filterAria")}
      className="input w-auto py-1.5 text-sm"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}
    >
      <option value="">{t("instructors.filterAll")}</option>
      {activeColleagues.map((instructor) => (
        <option key={instructor.id} value={instructor.id}>
          {instructor.fullName}
        </option>
      ))}
      {includeUnassigned && (
        <option value={UNASSIGNED_INSTRUCTOR}>{t("instructors.filterUnassigned")}</option>
      )}
    </select>
  );
};

export default InstructorFilterSelect;
